import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import {
  fetchStockTransferDetail,
  fetchStockTransfers,
  fetchStockTransferSummary,
} from '@/renderer/services/inventoryStockTransferService';
import type { StockTransferFilterParams } from '@/renderer/types/inventory';

export function useStockTransfers(params: StockTransferFilterParams) {
  return useQuery({
    queryKey: queryKeys.inventory.stockTransfersList(params),
    queryFn: () => fetchStockTransfers(params),
    enabled: !!params.companyId && !!params.outletId,
    placeholderData: keepPreviousData,
  });
}

export function useStockTransferDetail(
  companyId: number | null,
  transferId: string | null,
) {
  return useQuery({
    queryKey: queryKeys.inventory.stockTransferDetail(
      companyId ?? 0,
      transferId ?? '',
    ),
    queryFn: () => fetchStockTransferDetail(transferId!),
    enabled: !!companyId && !!transferId,
  });
}

export function useStockTransferSummary(
  companyId: number | null,
  outletId: string | null,
) {
  return useQuery({
    queryKey: queryKeys.inventory.stockTransferSummary(
      companyId ?? 0,
      outletId ?? '',
    ),
    queryFn: () => fetchStockTransferSummary(companyId!, outletId!),
    enabled: !!companyId && !!outletId,
  });
}
